import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort } from '@angular/material/sort';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { ISeasonSummary } from '@app/modules/compliance/model/seasonsummary';
import { SeasonSummaryService } from '../../services/season-summary.service';
import { ApiResult, ILookup } from 'src/app/shared/model/Index';
import { ISearchParam } from '@app/modules/search/model/searchParam';
import { ELookup } from '@app/modules/compliance/constants/eLookup';
import { LookupService } from '@app/modules/maintenance/services/lookup.service';
import { emptySearch } from '@app/modules/compliance/constants/prepareEmptyObject';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'season-summary',
  templateUrl: './season-summary.component.html'
})
export class SeasonSummaryComponent implements OnInit, AfterViewInit {
  public sportTypeList: ILookup[];
  search: ISearchParam = emptySearch();
  displayedColumns: string[] = ['sportSeason','sportType', 'institution', 'freshmanQualifierType', 'aid', 'hasSummerAid', 'eligibility', 'aidExempt', 'isMedicalHardship', 'redShirtType', 'isNinthSemester','participation'];
  dataSource = new MatTableDataSource<ISeasonSummary>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  constructor(
    private _lookupservice: LookupService,
    private _seasonsummaryservice: SeasonSummaryService,
    private _route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      this.search.studentId = params.id;
    });
    this.getActiveLookups(ELookup.SportType);
    this.searchSeasonSummary();
  }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
  }

  private getActiveLookups(tableName: string) {
    this._lookupservice.getActiveLookups(tableName).subscribe((result: ApiResult<ILookup[]>) => {
      if (result.validationErrors == null) {
        switch (tableName) {
          case ELookup.SportType:
            this.sportTypeList = result.value.filter(a=>a.disabled==false);
            break;        
          default:
            break;
        }
      }
    }, error => console.error(error));
  }
  public searchSeasonSummary() {
    this._seasonsummaryservice.search(this.search).subscribe((result: ApiResult<ISeasonSummary[]>) => {
      if (result.validationErrors == null) {
        this.dataSource = new MatTableDataSource<ISeasonSummary>(result.value);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    }, error => console.error(error));
  }
}
